export const PRMConfig = {
  useMockData: true,
};